<script>
  import { Link } from "@ObamaFoundation/of-design-system";

  export let subtitle = "";
  export let description = "";
  export let cta = null;
</script>

{#if subtitle}
  <p class="label mb-4">{subtitle}</p>
{/if}
<p class="body-sm">{description}</p>
{#if cta}
  <Link href={cta.url} class="mt-6 inline-block" variant="small" label={cta.text} />
{/if}
